export default class MainMenu {
	constructor() {
		if ("object" !== typeof gsap) return;

		this.options = {
			duration: 0.3,
			y: 0,
			opacity: 1,
		};

		this.initOptions = {
			y: "10px",
			opacity: 0,
		};

		this.navbar = document.getElementById("navbarNavOffcanvas");

		// this.menu.addEventListener("hidden.bs.offcanvas", (event) => {
		// 	console.log(event);
		// });

		// this.menu.addEventListener("hide.bs.offcanvas", (event) => {
		// 	console.log(event);
		// });

		// this.menu.addEventListener("hidePrevented.bs.offcanvas", (event) => {
		// 	console.log(event);
		// });

		// this.menu.addEventListener("show.bs.offcanvas", (event) => {
		// 	console.log(event);
		// });

		// this.menu.addEventListener("shown.bs.offcanvas", (event) => {
		// 	console.log(event);
		// });

		this.menuItems = Array.from(
			this.navbar.querySelectorAll(".primary-menu .menu-item")
		);

		this.rightArea = this.navbar.querySelector(".right-area");
		this.buttons = this.navbar.querySelector(".button-section");
		this.footerMenu = this.navbar.querySelector("#navbarSupportedContent");
		this.mobileFooterMenu = this.navbar.querySelector(".mobile-footer-menu");

		this.init();
		this.events();
	}

	initMenuItems() {
		this.menuItems && gsap.set(this.menuItems, this.initOptions);
	}

	initRightArea() {
		this.rightArea && gsap.set(this.rightArea, this.initOptions);
	}

	initFooterMenu() {
		this.footerMenu && gsap.set(this.footerMenu, this.initOptions);
	}

	initMobileFooterMenu() {
		this.mobileFooterMenu && gsap.set(this.mobileFooterMenu, this.initOptions);
	}

	initButtons() {
		this.buttons && gsap.set(this.buttons, this.initOptions);
	}

	init() {
		this.initMenuItems.bind(this)();
		this.initRightArea.bind(this)();
		this.initButtons.bind(this)();
		this.initFooterMenu.bind(this)();
		this.initMobileFooterMenu.bind(this)();
	}

	events() {
		this.navbar.addEventListener("shown.bs.offcanvas", (event) => {
			this.menuItems &&
				gsap.to(this.menuItems, { ...this.options, stagger: 0.07 });
			this.rightArea && gsap.to(this.rightArea, this.options);
			this.buttons && gsap.to(this.buttons, { ...this.options, stagger: 0.07 });
			this.footerMenu && gsap.to(this.footerMenu, this.options);
			this.mobileFooterMenu && gsap.to(this.mobileFooterMenu, this.options);
		});

		this.navbar.addEventListener("hidden.bs.offcanvas", (event) => {
			this.initMenuItems.bind(this)();
			this.initRightArea.bind(this)();
			this.initButtons.bind(this)();
			this.initFooterMenu.bind(this)();
			this.initMobileFooterMenu.bind(this)();
		});
	}
}
